import axios from "axios";
import { toast } from "react-toastify";
import { APIImpresoraTickets } from "../Constants/ApiConnection";

export const solicitarTicketParaImpresion = async (user, values) => {
  let url = APIImpresoraTickets + "api/ticket";

  try {
    const response = await axios.post(url, values, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        maxBodyLength: Infinity,
      },
      responseType: "blob",
    });

    // Verificar el valor en localStorage antes de mostrar el ticket
    const imprimirTicket = localStorage.getItem("imprimir_ticket");
    if (response.status === 200 && imprimirTicket === "true") {
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(pdfBlob);

      const printWindow = window.open(blobUrl);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.focus();
          printWindow.print();
          // Eliminar la llamada a printWindow.close() para que la ventana no se cierre automáticamente
          URL.revokeObjectURL(blobUrl); // Liberar memoria
        };
      } else {
        console.error("No se pudo abrir la ventana de impresión.");
      }

      return response;
    }
    // Si no está en true, no muestra el ticket
    return response;
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};


export const solicitarTicketParaImpresionOrdenServicio = async (user, values) => {
  let url = APIImpresoraTickets + "api/ticket/ordendeservicio";

  try {
    const response = await axios.post(url, values, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        maxBodyLength: Infinity,
      },
      responseType: "blob",
    });

    // Verificar el valor en localStorage antes de mostrar el ticket
    const imprimirTicket = localStorage.getItem("imprimir_ticket");
    if (response.status === 200 && imprimirTicket === "true") {
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(pdfBlob);

      const printWindow = window.open(blobUrl);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.focus();
          printWindow.print();
          // Eliminar la llamada a printWindow.close() para que la ventana no se cierre automáticamente
          URL.revokeObjectURL(blobUrl); // Liberar memoria
        };
      } else {
        console.error("No se pudo abrir la ventana de impresión.");
      }

      return response;
    }
    // Si no está en true, no muestra el ticket
    return response;
  } catch (error) {
    console.error(error);
    toast.error(error.response.data.message);
    return error;
  }
};
